<template>
  <div id="wz">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title" v-if="this.ggtitle.hasOwnProperty($route.params.ret)">{{ggtitle[$route.params.ret]}}</div>
        <div class="title" v-if="this.tzzjytitle.hasOwnProperty($route.params.ret)">{{tzzjytitle[$route.params.ret]}}
        </div>
        <div class="title" v-if="$route.params.ret==='zcgl'">资产管理公告
        </div>
        <div class="title"
             v-if="!this.ggtitle.hasOwnProperty($route.params.ret)
                   &&!this.tzzjytitle.hasOwnProperty($route.params.ret)
                   &&$route.params.ret!='zcgl'">
          常见问题
        </div>
      </div>
    </header>
    <div class="text" v-html="wz"></div>
    <div class="back">
      <router-link :to="{ name: 'gg', params: { nr: $route.params.ret }}"
                   v-if="this.ggtitle.hasOwnProperty($route.params.ret)">返回列表
      </router-link>
      <router-link :to="{ name: 'tzzjy', params: { nr: $route.params.ret }}"
                   v-if="this.tzzjytitle.hasOwnProperty($route.params.ret)">返回列表
      </router-link>
      <router-link :to="{ name: 'zcgl', params: { nr: 'gglist' }}"
                   v-if="$route.params.ret==='zcgl'">返回列表
      </router-link>
      <router-link :to="{ name: 'cjwt'}"
                   v-if="!this.ggtitle.hasOwnProperty($route.params.ret)
                   &&!this.tzzjytitle.hasOwnProperty($route.params.ret)
                   &&$route.params.ret!=='zcgl'">
        返回列表
      </router-link>
    </div>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'

  import ajax from '@/common/ajax/ajax'
  import title from '@/common/title/title'
  import router from '@/router'

  export default {
    name: 'wz',
    data () {
      return {
        wz: '文章读取中...',
        ggtitle: title.ggtitle,
        tzzjytitle: title.tzzjytitle
      }
    },
    created: function () {
      if (this.$route.params.ret !== 'cjwt') {
        if (this.$route.params.ret === 'zcgl') {
          ajax.getzcglWz(this.$route.params.nr).then(
            data => {
              this.wz = data
            },
            () => {
              router.replace({name: 'zcgl', params: {nr: 'login'}})
            }
          )
        } else {
          ajax.getWz(this.$route.params.nr).then(
            data => {
              this.wz = data
            }
          )
        }
      } else {
        this.wz = this.$route.params.nr
      }
    },
    components: {
      OffCanvas,
      ICP
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #wz
    .text
      padding 15px $bj 0 $bj
      span
        margin-left 0
    .back
      width 100%
      text-align center
      margin 40px 0 40px 0
      a
        color $font_color5
        font-size 13px
        text-decoration: underline;
</style>



// WEBPACK FOOTER //
// wz.vue?bb1ff2be